/* Step 13 · P2 (owner answer 03-Nov-2026 19:42 KSA, card V3 item 1) — EN + AR of the label on the Disclosure Checklist screen next
   to the Reference column: the references are the imported checklist library's own (kept as imported; to be verified against
   the IFRS text in a later card). No standard paragraph is quoted. */
const I18N_S13P2_DC_REFS = {
  en: {
    s13p2: {
      dcRefSource: "References from the imported checklist library",
    },
  },
  ar: {
    s13p2: {
      // Step 13 · owner card V6 item 4: the Arabic follows the English word for word (the EN has no "Disclosure", so no "الإفصاح").
      // References = مراجع (plural of dc.col.ref "المرجع") · from = من · imported = المستوردة (agingExtras.rowsImported
      // "الصفوف المستوردة") · checklist = القائمة (dc.loading "جاري تحميل القائمة…" / dc.exp.blank "قائمة فارغة") · library =
      // مكتبة (proc.source.library "المكتبة")
      dcRefSource: "مراجع من مكتبة القائمة المستوردة",
    },
  },
};

export default I18N_S13P2_DC_REFS;
